exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-fade-enter-active[data-v-7d854200]{transition:all 0.1s ease}.slide-fade-leave-active[data-v-7d854200]{transition:all 0.1s ease}.slide-fade-enter[data-v-7d854200],.slide-fade-leave-to[data-v-7d854200]{transform:translateY(-20px);opacity:0}.wrapperIcon[data-v-7d854200]{cursor:pointer}.form-title[data-v-7d854200]{font-size:16px;font-weight:900;padding-bottom:10px;border-bottom:1px solid #ccc;display:flex;justify-content:space-between}\n", ""]);

// exports
